import { apiGet, apiPost } from "./apiService";

const endpoints = {
  generate: "/email-generator/generate",
  job: (jobId: string) => `/email-generator/generate/${jobId}`,
};

export type EmailTone = "Formal" | "Neutral" | "Informal";
export type EmailLength = "Short" | "Medium" | "In-Depth";
export type EmailRelationship = "cold" | "warm" | "hot";

export interface GenerateEmailRequest {
  tone: EmailTone;
  length: EmailLength;
  email: string;
  recipient_email: string;
  relationship?: EmailRelationship;
  company_name?: string;
  landing_page?: string;
  contact_name?: string;
}

export interface GenerateEmailJob {
  job_id: string;
}

export interface EmailGenerationUsage {
  prompt_tokens: number;
  completion_tokens: number;
  total_tokens: number;
}

export type EmailGenerationJobStatus =
  | { job_id: string; status: "PENDING" }
  | {
      job_id: string;
      status: "COMPLETE";
      subject: string;
      content: string;
      usage: EmailGenerationUsage;
      analysis?: string;
    }
  | { job_id: string; status: "FAILED"; error: string };

// Generation can take longer than API Gateway's request timeout (scraping a site + multiple
// AI calls), so this queues a job and the caller polls getEmailGenerationJob for the result.
export const startEmailGeneration = (payload: GenerateEmailRequest): Promise<GenerateEmailJob> =>
  apiPost<GenerateEmailJob>(endpoints.generate, payload);

export const getEmailGenerationJob = (jobId: string): Promise<EmailGenerationJobStatus> =>
  apiGet<EmailGenerationJobStatus>(endpoints.job(jobId));
